import Vue from 'vue';
import Vuex from 'vuex';
import mutations from './mutations';
import actions from './action';
Vue.use(Vuex);
const state = {
    const:0,
    token:sessionStorage.getItem('token'),
    userName:sessionStorage.getItem('userName'),
    logins:false,
    otherDialogStatus:false,
}
export default new Vuex.Store({
    state,
    mutations,
    actions
})